import { render, staticRenderFns } from "./UseList.vue?vue&type=template&id=2fcc5e77&scoped=true"
import script from "./UseList.vue?vue&type=script&lang=js"
export * from "./UseList.vue?vue&type=script&lang=js"
import style0 from "./UseList.vue?vue&type=style&index=0&id=2fcc5e77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc5e77",
  null
  
)

export default component.exports